<oct-monitor></oct-monitor>
<oct-notifications></oct-notifications>
<oct-recent-activities></oct-recent-activities>
<div class="question-mark" matTooltip="Access product documentation and open cases for support">
    <a href="https://docs.cloudera.com/?tab=applications" id="questionMarkButton" target="_blank">
        <mat-icon svgIcon="questionMark"></mat-icon>
    </a>
</div>
<oct-user-profile></oct-user-profile>

<div [hidden]="[locations.adc, locations.adcDashboard, locations.settings].includes(location$ | async)"
     class="right-panel-toggle"
     [matTooltip]="tooltipText"
     #connectionsTooltip="matTooltip"
     matTooltipClass="custom-tooltip"
     [matTooltipPosition]="'below'">
    <div class="m-nav__link m-dropdown__toggle">
        <span class="m-nav__link-icon">
            <a (click)="openSideBar()" clickOutSideExclude>
                <img alt="" class="panel-box" clickOutSideExclude
                     [src]="hasUserMadeChanges ? './assets/right_panel_toggle_orange.svg' : './assets/right_panel_toggle.svg'"/>
            </a>
        </span>
    </div>
</div>
